import { createApi } from '@reduxjs/toolkit/query/react';

import { URL } from 'api/constants';
import { addParamsToUrl } from 'utils/query';

import { apiQuery } from '../../query';

import { PaymentMethod } from './types';

const tagTypes = ['payment-methods'];

export const paymentMethodsApi = createApi({
  tagTypes,
  baseQuery: apiQuery,
  reducerPath: 'paymentMethodsApi',
  endpoints: (build) => ({
    edit: build.mutation({
      invalidatesTags: tagTypes,
      query: (data) => ({
        data,
        method: 'put',
        url: URL.PAYMENT_METHOD.replace(':id', data.id),
      }),
    }),
    list: build.query<PaymentMethod[], Pick<PaymentMethod, 'status'>>({
      providesTags: tagTypes,
      query: (query) => ({
        method: 'get',
        url: addParamsToUrl(URL.PAYMENT_METHODS, query),
      }),
    }),
    saveAll: build.mutation<void, Partial<PaymentMethod>[]>({
      invalidatesTags: tagTypes,
      query: (data) => ({
        method: 'put',
        url: URL.PAYMENT_METHODS,
        data: {
          data: JSON.stringify(data.filter((item) => item.name)),
        },
      }),
    }),
  }),
});

export const { useListQuery, useEditMutation, useSaveAllMutation } =
  paymentMethodsApi;
export type { PaymentMethod };
